// extracted by mini-css-extract-plugin
export default {"icon":"remove_icon-module___icon___c1c8c47f","background":"remove_icon-module___background___f01bc81f"};